import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const curriculumData = {
  curriculum: [
    {
      title: 'Programming Foundations',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '6 weeks',
      tag: null,
      data: [],
      skills: [],
      anchor: 'dsa',
      cardTitle: null,
      cards: [
        {
          data: [
            `<p>Establish a strong <b>Python programming foundation</b> for your data analytics career by mastering <b>essential coding skills</b> and <b>core programming concepts</b>.</p>
<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
  <li>Gain proficiency in Python syntax, data structures, and control flow statements.</li>
  <li>Write reusable code using functions, modules, and file-handling techniques.</li>
  <li>Confidently solve programming problems and apply Python library methods.</li>
  <li>Handle errors and exceptions effectively in your programs.</li>
  <li>Understand object-oriented programming (OOP) and make API calls for data handling.</li>
  <li>Grasp basic Statistics and Probability for data interpretation.</li>
</ul>`,
          ],
          title: '',
          skills: [
            'Python Foundations',
            'Data Structures',
            'Control Flow',
            'Functions',
            'Modules',
            'File Handling',
            'Libraries',
            'Error Handling',
            'Object Oriented Programming',
            'Statistics',
            'Probability',
          ],
          tag: 'python-foundations',
        },
      ],
    },
    {
      title: 'Data Analysis with Excel',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '4 weeks',
      tag: null,
      data: [
        `<p>Build a strong foundation in Excel and learn to transform raw data into clear, actionable insights through powerful formulas, visualizations, and dashboards.</p>
<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
  <li>Learn essential Excel formulas including logical, text, lookup, and statistical functions.</li>
  <li>Clean and organize datasets using techniques like filtering, sorting, and data validation.</li>
  <li>Create impactful data visualizations using charts, conditional formatting, and sparklines.</li>
  <li>Design professional reports and dashboards to communicate insights effectively.</li>
</ul>`,
      ],
      skills: [
        'Excel Formulas',
        'Data Cleaning',
        'Data Visualization',
        'Pivot Tables',
        'Charts & Graphs',
        'Dashboard Creation',
        'Conditional Formatting',
        'Data Validation',
        'Reporting',
        'Sorting & Filtering',
      ],
      anchor: 'dsa',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Database Quries',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '4 weeks',
      tag: null,
      data: [
        `<p>Develop a strong command on SQL to extract, analyze, and manipulate data from relational databases for real-world business scenarios.</p>
<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
  <li>Understand database concepts and learn to write efficient SQL queries using SELECT, WHERE, GROUP BY, and ORDER BY.</li>
  <li>Perform data aggregation with functions like SUM, COUNT, AVG, MIN, and MAX.</li>
  <li>Work with joins, subqueries, and views to combine and filter data across multiple tables.</li>
  <li>Practice optimizing queries and managing structured data using real datasets.</li>
</ul>`,
      ],
      skills: [
        'SQL Queries',
        'Data Manipulation',
        'Data Aggregation',
        'Joins',
        'Subqueries',
        'Query Optimization',
      ],
      anchor: 'dsa',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'EDA and Visualisation',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '8 weeks',
      tag: null,
      data: [
        `<p>Harness the power of Python and leading BI tools to perform in-depth data analysis and craft stunning visual stories across diverse domains.</p>
<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
  <li>Use popular Python libraries like Pandas, NumPy, and SciPy for data modeling, numerical operations, and statistical analysis.</li>
  <li>Build compelling visualizations using matplotlib, Seaborn, and Plotly to explore patterns and trends.</li>
  <li>Create interactive dashboards in Power BI to deliver insights effectively across business use cases.</li>
  <li>Work on domain-based projects—ranging from finance and retail to healthcare and operations—to gain hands-on, industry-relevant experience.</li>
</ul>`,
      ],
      skills: [
        'NumPy',
        'Pandas',
        'SciPy',
        'Seaborn',
        'Plotly',
        'Matplotlib',
        'Power BI',
        'Dashboarding',
        'Data Storytelling',
      ],
      anchor: 'dsa',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Interview Blitz',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Two.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      data: [
        '<p>Prepare to succeed in <b>data analytics interviews</b> with focused <b>interview preparation</b>, <b>mock interviews</b>, and <b>aptitude assessments</b>.</p><ul><li>Perfect your interview skills for Data Analysis roles through multiple AI-driven practice sessions.</li><li>Practice the most commonly asked technical questions, including logic building and data manipulation challenges, to ace your interview.</li><li>Take part in timed mock interviews and solve take-home assignments focused on real-world data problems and AI applications.</li><li>Build confidence for upcoming interviews by engaging in mock sessions, focusing on AI integration and problem-solving techniques.</li><li>Master Aptitude, Statistics, and Probability assessments with an emphasis on logical reasoning and AI-enhanced data insights.</li></ul>',
      ],
      skills: [
        'Interview Preparation',
        'Mock Interviews',
        'Aptitude',
        'Conceptual Interview Questions Prep',
        'Take-Home Challenges',
      ],
      anchor: 'dsa',
      cardTitle: null,

      cards: [],
    },
    {
      title: 'Industry Projects and Case Studies',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '6 weeks',
      tag: null,
      chip: 'career step up',
      data: [
        '<p>Gain real-world experience by working on <b>domain-specific projects</b> and <b>case studies</b>, showcasing your <b>data analytical</b> skills across areas like <b>eCommerce</b>, <b>finance</b>, and more.</p><ul><li>Perform end-to-end Exploratory Data Analysis (EDA) on real-world datasets, using AI to enhance insights and streamline processes.</li><li>Load, inspect, clean, and transform data using Python libraries like NumPy and Pandas while leveraging AI for faster data cleaning and transformation.</li><li>Visualize data using Seaborn, and AI-driven tools to create insightful visualizations and dashboards.</li><li>Use AI-powered techniques to extract hidden patterns and fast-track analysis, integrating data storytelling for compelling insights.</li><li>Work on case studies using AI to derive actionable insights, and present findings through interactive dashboards and AI-assisted storytelling.</li></ul>',
      ],
      skills: [
        'Data Storytelling',
        'Exploratory Data Analysis',
        'Case Studies',
        'Business Applications',
      ],
      anchor: 'dsa',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Data Structures and Algorithms',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '8 weeks',
      chip: 'career step up',
      tag: null,
      data: [
        '<p>Build a strong foundation in <b>logic building</b> and enhance your <b>problem-solving skills</b> by mastering essential <b>data structures</b> and <b>algorithm techniques</b> critical for real-world applications.</p><ul><li>Build logic through solving array, string, math, recursion, and implementation problems relevant to data analytics.</li><li>Understand and apply Time & Space complexity in solving analytical problems.</li><li>Get introduced to fundamental data structures like LinkedLists and Trees, and their traversal techniques.</li><li>Learn problem patterns that involve arrays and how they relate to data manipulation in analytics.</li><li>Solve commonly asked problems across these patterns, focusing on logic building for data-driven decision-making.</li></ul>',
      ],
      skills: [
        'Logic Building',
        'Recursion',
        'Collections',
        'Introduction to Data Structures',
        'Space and Time Complexity',
        'Matrix',
        'Two Pointers',
        'Sliding Window',
        'Prefix Sum',
        'Bit Manipulation',
        'Sorting',
        'Binary Search',
      ],
      anchor: 'dsa',
      cardTitle: null,
      cards: [],
    },

    // {
    //   title: 'Advanced Backend Engineering',
    //   staticImage: (
    //     <StaticImage
    //       imgStyle={{ objectFit: 'contain' }}
    //       loading="lazy"
    //       src="../images/v5/CurriculumIcons/One.png"
    //       placeholder="blurred"
    //       alt="Mobile Navbar"
    //     />
    //   ),
    //   image: null,
    //   duration: '4 weeks',
    //   tag: null,
    //   data: [
    //     'Build advanced features for QEats, a Swiggy-like food ordering app. Solve for performance bottlenecks in the backend and improve REST API performance.',
    //   ],
    //   skills: [
    //     'Spring Security',
    //     'Caching',
    //     'Redis',
    //     'JMeter',
    //     'Multi-threading',
    //   ],
    //   cardTitle: null,
    //   cards: null,
    // },
    // {
    //   title: 'Advanced System Design',
    //   staticImage: (
    //     <StaticImage
    //       imgStyle={{ objectFit: 'contain' }}
    //       loading="lazy"
    //       src="../images/v5/CurriculumIcons/Two.png"
    //       placeholder="blurred"
    //       alt="Mobile Navbar"
    //     />
    //   ),
    //   image: null,
    //   duration: '6 weeks',
    //   tag: null,
    //   data: [
    //     'Master Low Level Design and get an introduction into various components/concepts in High Level Design through workshops, projects, and hands-on activities.',
    //   ],
    //   skills: null,
    //   cardTitle:
    //     'Curriculum to crack System Design interviews for super-dream jobs',
    //   cards: [
    //     {
    //       image: null,
    //       data: [
    //         '<p>Build a Hackerrank like contest platform by applying your Core Java and Low Level design skills<ul><li>Design & implement the classes required for a contest to work.</li><li>Implement the business logic of running a simulated contest.</li></ul></p>',
    //       ],
    //       skills: [
    //         'Machine Coding',
    //         'SOLID Principles',
    //         'Object Oriented Design',
    //         'Clean Architecture',
    //         'Design Patterns',
    //         'Schema Design',
    //       ],
    //       title: 'Build a Hackerrank-like App to master Low Level Design',
    //     },
    //     {
    //       image: null,
    //       data: [
    //         'Learn the art of cracking Machine Coding rounds with solid Low Level Design(LLD) skills',
    //       ],
    //       skills: null,
    //       title: 'Build Low Level Design for a iTunes-like App',
    //     },
    //     {
    //       image: null,
    //       data: [
    //         'Understand essential components/concepts of a modern tech stack used universally by internet companies with bonus hands-on exercises.',
    //       ],
    //       skills: [
    //         'Docker',
    //         'Kafka',
    //         'CDN',
    //         'Load Balancer',
    //         'Deployment',
    //         'Micro-Services',
    //         'CI/CD',
    //         'Cloud',
    //       ],
    //       title: 'High Level Design Concepts',
    //     },
    //     {
    //       image: {
    //         childImageSharp: {
    //           gatsbyImageData: {
    //             layout: 'constrained',
    //             placeholder: {
    //               fallback:
    //                 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC6ElEQVQ4y3WVS0hUURjH//eOEoEEbVtHC2lVi4LooYEwo7UIE3xMoahjvl8z99wZa0KyB6bO3DuNtUlqE20kwWgVBbULIiEqEBQJo1qIKzOI+4/7vlfHxeGec8/5fud7H0ATgKZUQlMWoSlb0AShKwY0YUA35yWGtWedoS1jyZoMuLBNX8A5qCv0vu7w1oLexd4lyqbFsuj2j21o7gFXQ4VyQWGkkKJkAT24YZ21NTQsWZuxCEtl3dnQA6boig2ZyhCT14mZdAAq7K8r4ypisgI+o70ZMDOXZnShlcWPMVY+67LWUkGEobowAgoRzg3+hmMmpjNsfNVC/jvM+T/VPPCll3L2CuWpYaKg+lBdhKG+33ygNfIqX6+eYW4jSiyrxEqKZfEoI92NRFF1TS4B3JUW9qFILsVj7xLEjyTxU6H0tI04WU001RMP9gDqHjCcFpI3F5TnEsSNRuL0ecqxGuJmD1FMO0AvZUoANWGDzDGjEoUMy8YTlMf7iOwAMdJBOZsgJnoJLaChF1TFBQYSNq8SOZWH5gZ5cKaPUrbL9pc5HmUIbYwVt9opz47YUF31I+2mUbAq9hdH+eRzDfm3kgNLF4i7vZR1R/Npleeet7N2OU6sJikt9FO6N+j60w+sCTMrAffH2PamkeQRTvyqI9ZTjNxpYPlQ3PLZPj3J6NerjHwfJtaSlJb6Wd5xkfLtXhMaMtmAmXdTwqh4O8SjvzuJdUGsJInmOkq1USKfolQUxLcksTZKbAji5TXiVBWlnhbiYcZA3jfZsKtCMfBYEB+SxPtuIllPHD9LNF22zcopxIsU8WmQmG8nLsWIE1WE0knMpkNAxwdmUIQh51PEYCsRrSPiDcTkiF0ZeWufmBwimhuIWB0x0EoUAgGxSs9rDk5jMB1r5pl5galZqMwUe21G3ZwX0zuag9gKty/dMd/vIjsbwc4u4863nfliuMGGc2onpNS6ZIMNPwF2ThqhbrzXE6DvfgL+AxeqJsiziNC8AAAAAElFTkSuQmCC',
    //             },
    //             backgroundColor: 'transparent',
    //             images: {
    //               fallback: {
    //                 src: '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png',
    //                 srcSet:
    //                   '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f159a/Six.png 600w',
    //                 sizes: '(min-width: 300px) 300px, 100vw',
    //               },
    //               sources: [
    //                 {
    //                   srcSet:
    //                     '/static/d55c8df9a40f9b3fe9147dc1b15cb291/5de9a/Six.webp 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f0b89/Six.webp 600w',
    //                   type: 'image/webp',
    //                   sizes: '(min-width: 300px) 300px, 100vw',
    //                 },
    //               ],
    //             },
    //             width: 300,
    //             height: 300,
    //           },
    //         },
    //       },
    //       data: null,
    //       skills: null,
    //       title: null,
    //     },
    //   ],
    // },
  ],
};
